/**
 * @typedef {import('../types/DateToStringOptions').default} Options
 */

/**
 * @param {Date} date
 * @param {Options | undefined} options
 * @returns {string}
 */
function convertDateToDateString(date, options) {
	if (!(date instanceof Date)) {
		return date;
	}

	/**
	 * @type {{day: 'numeric', month:'long', year: 'numeric', hour?: 'numeric', minute?: 'numeric', timeZoneName?: 'short'}}
	 */
	const formatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};

	if (options?.withTime) {
		formatOptions.hour = 'numeric';
		formatOptions.minute = 'numeric';
		formatOptions.timeZoneName = 'short';
	}

	return date.toLocaleDateString(options?.locale, formatOptions);
}

/**
 * @param {Date} date
 * @returns {string}
 */
function convertDateToYearMonthDay(date) {
	return date.toISOString().split('T')[0];
}

/**
 * @param {string} yearMonthDay
 * @returns {Date}
 */
function convertYearMonthDayToDate(yearMonthDay) {
	const isoString = convertYearMonthDayToIsoString(yearMonthDay);
	return new Date(isoString);
}

/**
 * @param {string} yearMonthDay
 * @returns {string}
 */
function convertYearMonthDayToIsoString(yearMonthDay) {
	const year = yearMonthDay.slice(0, 4);
	const month = yearMonthDay.slice(4, 6);
	const day = yearMonthDay.slice(6);
	return `${year}-${month}-${day}T00:00:00.000z`;
}

module.exports = {
	convertDateToDateString,
	convertDateToYearMonthDay,
	convertYearMonthDayToDate,
	convertYearMonthDayToIsoString,
};
